import React from 'react';
import { Link } from 'gatsby';

interface DataContext {
  drupalData: Queries.paragraph__header;
}

export default function Header({drupalData}: DataContext): React.JSX.Element {
  const breadcrumbs = drupalData.relationships.node__page[0].path.breadcrumbs;
  const parentPage = breadcrumbs
    ? breadcrumbs[breadcrumbs.length - 1]
    : null;

  return (
    <header className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12">
            {parentPage ? (
              <Link
                to={parentPage.path!}
                className="vl-link vl-link--large vl-link--bold vl-u-spacer--small vl-u-spacer-top--medium"
              >
                {parentPage.label}
              </Link>
            ) : (<></>)}

            <h1 className="vl-title vl-title--h1 vl-title--no-space-bottom vl-u-spacer--small">
              {drupalData.field_title}
            </h1>
          </div>
          <div
            className={
              'vl-col--12-12 vl-col--12-12--m vl-col--12-12--s ' +
              (drupalData.field_description ? '' : 'vl-u-hidden')
            }
          >
            <p className="vl-introduction">{drupalData.field_description}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
